module.exports = __webpack_public_path__ + "media/Video 1.8b16aa03.mp4";